import { useMemo } from 'react'

import { Translation } from 'cng-common/features/translations'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { IKeyInitiativeSuggestion } from '../../../../../../model/types'

import { SuggestionItem } from './components/suggestionItem'

import styles from './TopSuggestions.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS

const MAX_SUGGESTIONS = 2

interface ITopSuggestionsProps {
  suggestions: IKeyInitiativeSuggestion[]
  initiativesById: Map<number, string>
  isSaving?: boolean
  onSelect: (keyInitiativeId: number) => void
}

export const TopSuggestions = ({
  suggestions,
  initiativesById,
  isSaving,
  onSelect,
}: ITopSuggestionsProps) => {
  const topSuggestions = useMemo(() => {
    return suggestions
      .map((suggestion) => ({
        ...suggestion,
        name: initiativesById.get(suggestion.keyInitiativeId),
      }))
      .filter((suggestion) => suggestion.name)
      .sort((a, b) => b.matchPercent - a.matchPercent)
      .slice(0, MAX_SUGGESTIONS)
  }, [suggestions, initiativesById])

  if (topSuggestions.length === 0) {
    return (
      <span className={styles.noSuggestions}>
        <Translation text={KEYS.linkage.noSuggestions} />
      </span>
    )
  }

  return (
    <div className={styles.suggestions}>
      {topSuggestions.map((suggestion) => {
        if (suggestion.name) {
          return (
            <SuggestionItem
              key={suggestion.keyInitiativeId}
              label={suggestion.name}
              matchPercent={suggestion.matchPercent}
              disabled={isSaving}
              onClick={() => onSelect(suggestion.keyInitiativeId)}
            />
          )
        }

        return null
      })}
    </div>
  )
}

TopSuggestions.displayName = 'TopSuggestions'
